import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './responsive-area.module.css';

export function ResponsiveArea({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        styles.container,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {children}
    </div>
  );
}
